export const LOCAL_STORAGE_FEATURE_FLAGS = 'featureFlags';

const getLocalFeatureFlags = () => {
    try {
        const flags = localStorage?.getItem(LOCAL_STORAGE_FEATURE_FLAGS);
        if (flags) {
            return JSON.parse(flags);
        }
    } catch {
        // Intentionally empty.
    }
    return {};
};

export const createFlagGetter = (flag: string) => {
    return () => getLocalFeatureFlags()[flag];
};

export const createFlagSetter =
    <T extends string | boolean | number>(flag: string) =>
    (value: T) => {
        try {
            const flags = getLocalFeatureFlags();
            flags[flag] = value;
            localStorage?.setItem(LOCAL_STORAGE_FEATURE_FLAGS, JSON.stringify(flags));
        } catch {
            // Intentionally empty.
        }
    };

export const clearFlagFromLocalStorage = (flag: string) => () => {
    try {
        const flags = getLocalFeatureFlags();
        delete flags[flag];
        localStorage?.setItem(LOCAL_STORAGE_FEATURE_FLAGS, JSON.stringify(flags));
    } catch {
        // Intentionally empty.
    }
};
